import { iconBaseProps, type FillableIconProps } from "@/components/ui/icons/icon-base"

export const UserIcon = ({ size = 22, filled = false, ...props }: FillableIconProps) =>
  filled ? (
    <svg {...iconBaseProps(size, props)} fill="currentColor">
      <circle cx="12" cy="8" r="4.6" />
      <path d="M12 14.2c-4.5 0-8.1 2.9-8.1 6.4 0 .8.6 1.4 1.4 1.4h13.4c.8 0 1.4-.6 1.4-1.4 0-3.5-3.6-6.4-8.1-6.4Z" />
    </svg>
  ) : (
    <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  )
